import React, { useEffect, useState } from "react";

import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker, Popup, Polygon } from "react-leaflet";
import L from "leaflet";
import http from '../../Api/http';

const center = {
    lat: 31.8706696,
    lng: 35.5315952
};
const busIcon = new L.Icon({
    iconUrl: "/images/bus.png",
    iconSize: [30, 30],
});

const truckIcon = new L.Icon({
    iconUrl: "/images/truck.png",
    iconSize: [35, 35],
});

const personIcon = new L.Icon({
    iconUrl: "/images/person.png",
    iconSize: [40, 40],
});

export default function DriversMap() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language || 'ar';
    const [drivers, setDrivers] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);

    // const { isLoaded } = useJsApiLoader({
    //     googleMapsApiKey: 'AIzaSyCJYCzYotMrrHAUNrVSueighYiFa4yFmtU'
    // });

    useEffect(() => {
        loadDrivers();
        loadAreas();

        const interval = setInterval(loadDrivers, 10000);
        return () => clearInterval(interval);
    }, []);

    const loadDrivers = async () => {
        const res = await http.getJsonAxios(http.actions.Traffic.GetDriversOnMap);
        if (res.status === 200) setDrivers(res.data);
    };

    const loadAreas = async () => {
        const res = await http.getJsonAxios(http.actions.Traffic.GetTrackAreas);
        if (res.status === 200) setAreas(res.data);
    };

    // Convert trackTime to HH:mm
    const getTimeOnly = (trackTime) => {
        if (!trackTime) return "";
        const date = new Date(trackTime);
        return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    };


    return (
        <div style={{ position: "relative", zIndex: 1 }}>
            <MapContainer
                center={center}
                zoom={17}
                minZoom={10}
                style={{ height: "655px", width: "100%" }}
            >
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution="Tiles © Esri"
                />
                <TileLayer
                    url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
                />


                {/* Polygons */}
                {areas.map(area => (
                    <Polygon
                        key={area.Id}
                        positions={area.Points.map(p => [p.Lat, p.Lng])}
                        pathOptions={{
                            color: area.AreaColor || "#097138",
                            fillColor: area.AreaColor || "#097138",
                            fillOpacity: 0.25,
                        }}
                    >
                        <Popup>
                            <div>
                                <strong>
                                    {area.Name}
                                </strong>
                            </div>
                        </Popup>
                    </Polygon>
                ))}

                {/* Markers */}
                {drivers.map(driver => (
                    <Marker
                        key={driver.UserId}
                        position={[driver.Latitude, driver.Longitude]}
                        icon={driver.VehicleType === 3 && driver.BusNo ? busIcon : driver.VehicleType === 8 && driver.BusNo ? truckIcon : personIcon}
                    >
                        <Popup>
                            <div>
                                <strong>
                                    {driver.UserName}
                                    {driver.BusNo && ` (${driver.BusNo})`}
                                </strong><br />
                                <strong>{driver.LocationName}</strong><br />
                                <strong>{getTimeOnly(driver.TrackTime)}</strong>
                            </div>
                        </Popup>
                    </Marker>
                ))}

            </MapContainer>
        </div>
    );
}
